import { Col, Image, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import vellfireImg from '../assets/vellfire.jpg';
import {
  isSph2026Campaign,
  isUobSbf2026Campaign,
  SPH_2026_CAMPAIGN,
  UOB_SBF_2026_CAMPAIGN,
} from '../campaign/uob-sbf-2026';
import { useAuthState } from '../states/auth.state';
import './SLayout.css';

const SLogin = () => {
  const authState = useAuthState();
  const { pathname } = useLocation();

  // Route-based check: sessionStorage alone does not re-render SLogin
  const onCampaignHome =
    pathname === UOB_SBF_2026_CAMPAIGN.path ||
    pathname === SPH_2026_CAMPAIGN.path ||
    pathname.startsWith(`${UOB_SBF_2026_CAMPAIGN.path}/`) ||
    pathname.startsWith(`${SPH_2026_CAMPAIGN.path}/`);

  const hideCampaignSideBanner =
    onCampaignHome || isUobSbf2026Campaign() || isSph2026Campaign();

  if (authState.get().currentUser) {
    return <></>;
  }

  if (hideCampaignSideBanner) {
    return <></>;
  }

  return (
    <section className="login-wrapper">
      <Row>
        <Col className="px-0 text-center">
          <Image src={vellfireImg} fluid className="image-fix" />
        </Col>
      </Row>
    </section>
  );
};

export default SLogin;
